import { RootState } from 'store/types';
import { createSelector } from 'reselect';

export const lowPriorityItemSelector = (state: RootState) => state.priorityItems.lowPriorityItems;
export const highPriorityItemSelector = (state: RootState) => state.priorityItems.highPriorityItems;

export const lowPriorityItemsSelector = createSelector(lowPriorityItemSelector, actionItems => {
  return actionItems.data;
});

export const highPriorityItemsSelector = createSelector(
  highPriorityItemSelector,
  actionItems => actionItems.data
);

export const lowPriorityItemsRequestStateSelector = createSelector(
  lowPriorityItemSelector,
  lowPriorityItems => lowPriorityItems.requestState
);

export const highPriorityItemsRequestStateSelector = createSelector(
  highPriorityItemSelector,
  highPriorityItems => highPriorityItems.requestState
);

export const lowPriorityItemsIsFetchingSelector = createSelector(
  lowPriorityItemSelector,
  lowPriorityItems => lowPriorityItems.isFetching
);

export const highPriorityItemsIsFetchingSelector = createSelector(
  highPriorityItemSelector,
  highPriorityItems => highPriorityItems.isFetching
);
